export function logAnalyticsEvent(eventName, eventData) {
    if (typeof window.bananas !== 'undefined') {
        window.bananas('event', eventName, eventData);
    } else {
        // eslint-disable-next-line no-console
        console.log('banalytics not active, would like to log:', eventName, eventData);
    }
}
